import * as React from 'react';


export default class PrivacyPolicy extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <path fillRule="evenodd" clipRule="evenodd" d="M8.34799 14.3885H14.59V9.6105H8.34799V14.3885Z" stroke="#727272" strokeLinecap="round" strokeLinejoin="round"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M11.4509 6.78271V6.78271C10.3349 6.78271 9.42989 7.68771 9.42989 8.80471V9.60971H13.4729V8.80471C13.4729 7.68771 12.5679 6.78271 11.4509 6.78271Z" stroke="#727272" strokeLinecap="round" strokeLinejoin="round"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M12.1003 11.9995C12.1003 12.3485 11.8173 12.6315 11.4683 12.6315C11.1203 12.6315 10.8363 12.3485 10.8363 11.9995C10.8363 11.6495 11.1203 11.3675 11.4683 11.3675C11.8173 11.3675 12.1003 11.6495 12.1003 11.9995Z" fill="#727272"/>
        <path d="M6.57589 13.811H1.49989V1.5H12.0999V4.898" stroke="#727272" strokeLinecap="round" strokeLinejoin="round"/>
        <path opacity="0.01" fillRule="evenodd" clipRule="evenodd" d="M13.19 14.0875H14.59V9.6105H13.19V14.0875Z" fill="#53A9DE"/>
        <path d="M3.7634 4.11859H7.6974" stroke="#727272" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.7634 6.39398H7.6974" stroke="#727272" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.7634 8.6694H6.4214" stroke="#727272" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  }
}
